import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { ErrorText } from '../CustomInput/CustomInput';
import RequiredMark from '../ReqiuredMark';
import { Vector } from '../Svg/Svg';

const defaultStyles = {
    valueContainer: (provided, state) => ({
        ...provided,
        color: '#1C1C1C',
        fontSize: '14px',
        lineHeight: '22px',
        fontWeight: '400',
        backgroundColor: 'white',
        padding: '4px 8px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
            ? '#f4f4ff'
            : state.isSelected
            ? '#e5e6ff;'
            : 'white',
        ':active': {},
        color: '#1c1c1c',
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: '400',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    }),
    control: (provided, state) => ({
        ...provided,
        width: '100%',
        display: 'flex',
        borderColor: state.isFocused ? '#1c1c1c' : '#afafaf',
        boxShadow: 'none',
        color: '#1c1c1c',
        borderRadius: '4px',
        cursor: 'pointer',
        overflow: 'hidden',
        '&:hover': {
            // Overwrittes the different states of border
            borderColor: '#1c1c1c',
        },
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        backgroundColor: '#fff',
    }),
    indicatorSeparator: (provided, state) => ({
        ...provided,
        display: 'none',
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
        transition: 'transform 100ms linear',
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#e5e6ff',
        borderRadius: '4px',
        padding: '2px 8px',
        marginRight: '4px',
        marginTop: '4px',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#1c1c1c',
        fontSize: '14px',
        lineHeight: '22px',
        fontWeight: '400',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#1c1c1c',
        cursor: 'pointer',
        ':hover': {
            backgroundColor: '#d6d7fc',
        },
    }),
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <Vector />
        </components.DropdownIndicator>
    );
};

export default function CustomSelect({
    labelText,
    isRequired,
    name,
    className,
    onChange,
    options,
    value,
    placeholder,
    errorText,
    customStyles,
    isLoading,
    isDisabled = false,
    onKeyDown = () => null,
    isMulti = false,
    isCreatable = false,
    hideSelectedOptions = true,
    closeMenuOnSelect = true,
    isOptionSelected,
    defaultValue = options[0],
}) {
    const [error, setError] = useState(errorText || '');

    const styles = {
        ...defaultStyles,
        ...customStyles,
    };

    useEffect(() => {
        setError(errorText);
    }, [errorText]);

    const clearError = () => {
        setError('');
    };
    const selectedValues = isMulti
        ? value
        : options.find((option) => option.id === value);

    return (
        <>
            {labelText && (
                <label className="input-label">
                    {labelText}
                    {isRequired && <RequiredMark />}
                </label>
            )}
            {isCreatable ? (
                <CreatableSelect
                    className={error ? `${className} select__error` : className}
                    classNamePrefix="select"
                    name={name}
                    options={options}
                    styles={styles}
                    onChange={onChange}
                    onFocus={clearError}
                    value={value}
                    components={{ DropdownIndicator: () => null }}
                    placeholder={placeholder}
                    isLoading={isLoading}
                    noOptionsMessage={() => null}
                    onKeyDown={onKeyDown}
                    isMulti
                    hideSelectedOptions={hideSelectedOptions}
                    closeMenuOnSelect={closeMenuOnSelect}
                />
            ) : (
                <Select
                    className={error ? `${className} select__error` : className}
                    classNamePrefix="select"
                    name={name}
                    defaultValue={defaultValue}
                    options={options}
                    styles={styles}
                    onChange={onChange}
                    onFocus={clearError}
                    value={selectedValues}
                    components={{ DropdownIndicator }}
                    placeholder={placeholder}
                    isLoading={isLoading}
                    isMulti={isMulti}
                    hideSelectedOptions={hideSelectedOptions}
                    closeMenuOnSelect={closeMenuOnSelect}
                    isOptionSelected={isOptionSelected}
                    isDisabled={isDisabled}
                />
            )}
            {error && <ErrorText text={error[0]} />}
        </>
    );
}
